import { axios } from "../../helper/axios";
import { Dashboardconstant } from "./dashboardConstant";

const DashboardApi = {};

DashboardApi.getdashboardrevenue = (payload) => {
  const { status, model_id, station_id, manufacturer_id,from_date, to_date,vendor_id } = payload;
  var qeuryParam;

  if (status === "All") {
    status = "";
  }
  if (vendor_id==="All"){
    vendor_id=""
  }
  if (model_id === "All") {
    model_id = "";
  }
  if (station_id === "All") {
    station_id = "";
  }
  if (manufacturer_id === "All") {
    manufacturer_id = "";
  }
  if(from_date && to_date){
     qeuryParam = `?model_id=${model_id}&vendor_id=${vendor_id}&station_id=${station_id}&manufacturer_id=${manufacturer_id}&from_date=${from_date}&to_date=${to_date}`;
  }
  else {
    qeuryParam = `?model_id=${model_id}&vendor_id=${vendor_id}&station_id=${station_id}&manufacturer_id=${manufacturer_id}`;

  }
  


  return axios.get(`${Dashboardconstant.DASHBOARD_REVENUE_API}${qeuryParam}`);
};

DashboardApi.getapicustomer = (payload) => {
  const { status, model_id, station_id, manufacturer_id ,from_date, to_date,vendor_id} = payload;
  var qeuryParam;

  if (status === "All") {
    status = "";
  }
  if(vendor_id==="All"){
    vendor_id=""

  }
  if (model_id === "All") {
    model_id = "";
  }
  if (station_id === "All") {
    station_id = "";
  }
  if (manufacturer_id === "All") {
    manufacturer_id = "";
  }
  if(from_date && to_date){
    qeuryParam = `?model_id=${model_id}&vendor_id=${vendor_id}&station_id=${station_id}&manufacturer_id=${manufacturer_id}&from_date=${from_date}&to_date=${to_date}`;
 }
 else {
   qeuryParam = `?model_id=${model_id}&vendor_id=${vendor_id}&station_id=${station_id}&manufacturer_id=${manufacturer_id}`;

 }

  return axios.get(`${Dashboardconstant.CUSTOMERS_API}${qeuryParam}`);
};

DashboardApi.getapitimeconsumed = (payload) => {
  const { status, model_id, station_id, manufacturer_id,from_date, to_date,vendor_id } = payload;
  var qeuryParam;


  if (status === "All") {
    status = "";
  }
  if(vendor_id==="All"){
    vendor_id=""
  }
  if (model_id === "All") {
    model_id = "";
  }
  if (station_id === "All") {
    station_id = "";
  }
  if (manufacturer_id === "All") {
    manufacturer_id = "";
  }
  if(from_date && to_date){
    qeuryParam = `?model_id=${model_id}&vendor_id=${vendor_id}&station_id=${station_id}&manufacturer_id=${manufacturer_id}&from_date=${from_date}&to_date=${to_date}`;
 }
 else {
   qeuryParam = `?model_id=${model_id}&vendor_id=${vendor_id}&station_id=${station_id}&manufacturer_id=${manufacturer_id}`;

 }

  return axios.get(`${Dashboardconstant.TIME_CONSUMED_API}${qeuryParam}`);
};

DashboardApi.getapipowerconsumed = (payload) => {

  const { status, model_id, station_id, manufacturer_id,from_date, to_date,vendor_id } = payload;
  var qeuryParam;


  if (status === "All") {
    status = "";
  }
  if(vendor_id==="All"){
    vendor_id=""
  }
  if (model_id === "All") {
    model_id = "";
  }
  if (station_id === "All") {
    station_id = "";
  }
  if (manufacturer_id === "All") {
    manufacturer_id = "";
  }
  if(from_date && to_date){
    qeuryParam = `?model_id=${model_id}&vendor_id=${vendor_id}&station_id=${station_id}&manufacturer_id=${manufacturer_id}&from_date=${from_date}&to_date=${to_date}`;
 }
 else {
   qeuryParam = `?model_id=${model_id}&vendor_id=${vendor_id}&station_id=${station_id}&manufacturer_id=${manufacturer_id}`;

 }

  return axios.get(`${Dashboardconstant.POWER_CONSUMED_API}${qeuryParam}`);
};

DashboardApi.getapipopulartime = (payload) => {

  const { status, model_id, station_id, manufacturer_id,from_date, to_date,vendor_id } = payload;
  var qeuryParam;

  if (status === "All") {
    status = "";
  }
  if(vendor_id==="All"){
    vendor_id=""

  }
  if (model_id === "All") {
    model_id = "";
  }
  if (station_id === "All") {
    station_id = "";
  }
  if (manufacturer_id === "All") {
    manufacturer_id = "";
  }
  if(from_date && to_date){
    qeuryParam = `?model_id=${model_id}&vendor_id=${vendor_id}&station_id=${station_id}&manufacturer_id=${manufacturer_id}&from_date=${from_date}&to_date=${to_date}`;
 }
 else {
   qeuryParam = `?model_id=${model_id}&vendor_id=${vendor_id}&station_id=${station_id}&manufacturer_id=${manufacturer_id}`;

 }

  return axios.get(`${Dashboardconstant.POPULAR_TIMES_API}${qeuryParam}`);
};

export { DashboardApi };
